import { cspmEngine } from './cspm';
import { guarddutyEngine } from './guardduty';
import { macieEngine } from './macie';

// Ordered list of engines. Add inspector here later.
export const ENGINES = [cspmEngine, guarddutyEngine, macieEngine];
export const engineById = (id) => ENGINES.find((e) => e.id === id);
